import { Typography } from '@mui/material'
import { FC, ReactNode } from 'react'

/** Small section header for spotlight results */
export const SectionHeader: FC<{ children: ReactNode }> = ({ children }) =>
    <Typography
        variant="caption"
        color="text.secondary"
        sx={{ px: 2, pt: 2, pb: 1, display: 'block', fontWeight: 500 }}
    >
        {children}
    </Typography>
